import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Unlock = createReactComponent("Unlock", ["svg", defaultAttributes, [["rect", {
  x: "3",
  y: "11",
  width: "18",
  height: "11",
  rx: "2",
  ry: "2",
  key: "1jfkdd"
}], ["path", {
  d: "M7 11V7a5 5 0 019.9-1",
  key: "6fqo8o"
}]]]);
export default Unlock;